import { SELECTED_PROJECT } from "@configuration";
import { DropDownProfileOption } from "./DropDownProfileOption";
import { LanguageMenuItem } from "./LanguageMenuItem";

export const mainMenuItems = () => [
  { title: <DropDownProfileOption />, arg: "/my-profile" },
  // { title: "company", path: "/company" },
  // { title: "account", path: "/my-account" },
  // { title: "orders", path: "/my-orders" },
  // {
  //   title:
  //     SELECTED_PROJECT === "alliance" ? "datasetManagement" : "assetManagement",
  //   arg: SELECTED_PROJECT === "alliance" ? "/my-datasets" : "/asset-management",
  // },
  // ...(SELECTED_PROJECT === "alicia"
  //   ? [
  //       {
  //         title: "myRequests",
  //         arg: "/my-requests",
  //       },
  //     ]
  //   : []),
  // { title: "homePage", arg: "/" },
];

export const dropDownLanguagesData = [
  { title: "English", arg: "en-GB" },
  { title: "Ελληνικά", arg: "GR" },
];

export const dropDownLanguages = dropDownLanguagesData.map((item) => ({
  title: <LanguageMenuItem title={item.title} arg={item.arg} />,
  arg: item.arg,
}));
